import { jsx as _jsx } from "react/jsx-runtime";
import { StyledWrapper, StyledPlaceholder, } from './Placeholder.style';
export function Placeholder({ size = 'Medium', quantity = 3, }) {
    return (_jsx(StyledWrapper, { size: size, children: Array.from({ length: quantity }).map((_, index) => (_jsx(StyledPlaceholder, { size: size }, 'placeholder-' + index))) }));
}
//# sourceMappingURL=Placeholder.js.map